import { render, staticRenderFns } from "./DeviceRatingReviews.vue?vue&type=template&id=07013116&"
import script from "./DeviceRatingReviews.vue?vue&type=script&lang=js&"
export * from "./DeviceRatingReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07013116')) {
      api.createRecord('07013116', component.options)
    } else {
      api.reload('07013116', component.options)
    }
    module.hot.accept("./DeviceRatingReviews.vue?vue&type=template&id=07013116&", function () {
      api.rerender('07013116', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/devicereviews/DeviceRatingReviews.vue"
export default component.exports